import { ThemeOptions } from '@mui/material';

import {
  MuiAlert,
  MuiAvatar,
  MuiButton,
  MuiButtonBase,
  MuiChip,
  MuiContainer,
  MuiCssBaseline,
  MuiDataGrid,
  MuiIconButton,
  MuiInputLabel,
  MuiLinearProgress,
  MuiLink,
  MuiRating,
  MuiMenu,
  MuiMenuItem,
  MuiPaper,
  MuiSkeleton,
  MuiStack,
  MuiToggleButton,
  MuiTooltip,
  MuiRadio,
  MuiFormControlLabel,
  MuiCheckbox,
  MuiTypography,
  MuiInputBase,
  MuiFormControl,
  MuiOutlinedInput,
  MuiSelect,
  MuiList,
  MuiPickersInputBase,
  MuiPickersOutlinedInput,
  MuiDatePicker,
  MuiPickersDay,
  MuiYearCalendar,
  MuiFormHelperText,
  MuiDialog,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogTitle,
  MuiAutocomplete,
  MuiCard,
  MuiCardContent,
  MuiToggleButtonGroup,
  MuiPopover,
} from './components/index';

export const components: ThemeOptions['components'] = {
  MuiAlert,
  MuiAvatar,
  MuiButton,
  MuiButtonBase,
  MuiChip,
  MuiContainer,
  MuiCssBaseline,
  MuiDataGrid,
  MuiIconButton,
  MuiInputLabel,
  MuiLinearProgress,
  MuiLink,
  MuiRating,
  MuiMenu,
  MuiMenuItem,
  MuiPaper,
  MuiSkeleton,
  MuiStack,
  MuiToggleButton,
  MuiTooltip,
  MuiRadio,
  MuiFormControlLabel,
  MuiCheckbox,
  MuiTypography,
  MuiInputBase,
  MuiFormControl,
  MuiOutlinedInput,
  MuiSelect,
  MuiList,
  MuiPickersInputBase,
  MuiPickersOutlinedInput,
  MuiDatePicker,
  MuiPickersDay,
  MuiYearCalendar,
  MuiFormHelperText,
  MuiDialog,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogTitle,
  MuiAutocomplete,
  MuiCard,
  MuiCardContent,
  MuiToggleButtonGroup,
  MuiPopover,
};
